module.exports = __webpack_public_path__ + "media/src/images/icon_pdf-a47d165c6655ce06139704e6147ddb12.png";